import { Box } from '@mui/material'
import NavigationSkeleton from './navigation-skeleton.component'

/**
 * Layout Skeleton Component
 *
 * Shows only the navigation skeleton during initial auth loading.
 * The main content area is left empty because the page component
 * knows its own content (title, buttons, etc.) and can show it immediately.
 *
 * This prevents layout shift for the nav while allowing pages to render
 * their known content without waiting.
 */
export const LayoutSkeleton = ({ showNav = true }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        width: '100%',
        backgroundColor: 'gray.0',
      }}
    >
      {showNav && <NavigationSkeleton />}
      {/* Content area is intentionally empty - the page will render its own content */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          backgroundColor: 'gray.0',
        }}
      />
    </Box>
  )
}

export default LayoutSkeleton
